import type { MessageKey } from '@ralph/contracts'
import type { ServerMessages } from '@/i18n/messages/en/errors/index.ts'

/**
 * What the agents domain's refusals say, in English (the source of truth AND the type).
 *
 * The `Extract` rather than a hand-written union of key names: every `agents.*` key in the
 * contract belongs in this file, so adding one there and forgetting it here fails HERE,
 * naming the key, instead of failing in the aggregator that spreads ten of these.
 */
export const agents: Pick<ServerMessages, Extract<MessageKey, `agents.${string}`>> = {
  'agents.not_available': ({ name }) => `No agent called “${name}” is available to you.`,

  /**
   * Both numbers are printed ungrouped, deliberately: a version is an identifier, not a
   * quantity, and "version 1,024" reads as a measurement of something.
   */
  'agents.layer_version_conflict': ({ expected, found }) =>
    `Somebody else changed this agent while you were editing it — you started from version ${expected} and it is now at ${found}. Reload it and reapply your edit.`,

  'agents.layer_absent_for_if_match': () =>
    'This agent layer does not exist yet. Create it without an If-Match version.',

  // Two sentences, not one with an optional tail. The reasonless one ends in a full stop and
  // the other in a colon and somebody else's words, which is a different sentence in any
  // language and an unagreeable one in a gendered language (D-20).
  'agents.suspended': () => 'This agent is unavailable right now.',
  'agents.suspended_with_reason': ({ reason }) => `This agent is unavailable right now: ${reason}`
}
